/**
 * Strip unreliable embedded metadata from Claude-generated post_content.
 *
 * The blog generator sometimes injects lines like:
 *   **Published: January 22, 2026**
 *   ---
 *
 * These dates can conflict with the actual RSS publication date stored in the DB,
 * so we strip them before rendering. The real date is shown in the card header.
 */
export function cleanPostContent(raw: string): string {
  return raw
    // Remove "**Published: ...**" line (with optional surrounding blank lines / hr)
    .replace(/^\s*\*{0,2}Published:\s*[^*\n]+\*{0,2}\s*\n?/im, '')
    // Remove orphaned "---" separator left behind at the top
    .replace(/^\s*---\s*\n?/, '')
    .trim();
}
